import { render, staticRenderFns } from "./StatsDashboard.vue?vue&type=template&id=48a55a79&scoped=true&"
import script from "./StatsDashboard.vue?vue&type=script&lang=js&"
export * from "./StatsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./StatsDashboard.vue?vue&type=style&index=0&id=48a55a79&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a55a79",
  null
  
)

export default component.exports